module.exports = __webpack_public_path__ + "media/images/icons/icon_skp_point-20c6b6657a23c8d0cae27a8906295309.svg";